import { GroupTableType } from "helpers/models";
import getSerie from "./serie";
import y from "./y";
import x from "./x";
import title from "./title";
import grid from "./grid";

const get = (
  t: any,
  grouped: GroupTableType,
  count: number,
  text: string
) => ({
  title: title(t, text),

  grid,

  xAxis: x(count),

  yAxis: y(t, grouped),

  series: getSerie(grouped)
});

export default get;
